import React, { useEffect, useState } from "react";

import { GifList, IUserList } from "./GifList";
import { useCollectionItemsQuery } from "../../queries";
import { IGif, INicheMap } from "services/types";
import { filterGifsList } from "utils/filterGifsList";
import { filterNichesList } from "utils/filterNichesList";
import { filterUsersList } from "utils/filterUsersList";
import { ViewRegion } from "utils/metrics";

const PAGE_SIZE = 30;

export const CollectionFeed = (props: {
  user: string;
  collection: string;
  showPrivate: boolean;
  manage: boolean;
  onSelect?: (ids: string[]) => void;
}) => {
  const [page, setPage] = useState<number>(1);
  const [lastPage, setLastPage] = useState<number>(0);
  const [pages, setPages] = useState<number>(1);
  const [totalGifs, setTotalGifs] = useState<number>(0);
  const [gifs, setGifs] = useState<IGif[]>([]);
  const [users, setUsers] = useState<IUserList>({});
  const [topic, setTopic] = useState<string>("a");
  const [order, setOrder] = useState("trending");
  const [gifsError, setGifsError] = useState<boolean>(false);
  const [tiles, setTiles] = useState<boolean>(true);
  const [niches, setNiches] = useState<INicheMap>({});

  const rel = () => {
    return `c:${props.user}:${props.collection}`;
  };

  const gifQuery = useCollectionItemsQuery({
    user: props.user,
    collection: props.collection,
    page,
    count: PAGE_SIZE,
    showPrivate: props.showPrivate,
  });

  const reload = () => {
    setTotalGifs(0);
    setLastPage(0);
    setGifs([]);
    setPage(1);
  };

  const changeTopic = (value: string) => {
    console.debug(`[CollectionFeed] topic changed to ${value}`);
    setTopic(value);
    reload();
  };

  const changeOrder = (value: string) => {
    console.debug(`[CollectionFeed] order changed to ${value}`);
    setOrder(value);
    reload();
  };

  useEffect(() => {
    if (gifQuery.isSuccess && gifQuery.data !== undefined) {
      if (gifQuery.data.page !== lastPage) {
        setLastPage(gifQuery.data.page);

        setGifs(prev => filterGifsList(prev, gifQuery.data.gifs));
        setPages(gifQuery.data.pages);
        setTotalGifs(gifQuery.data.total);
        setUsers(prev => filterUsersList(prev, gifQuery.data.users));

        if (gifQuery.data.niches) {
          setNiches(prev => filterNichesList(prev, gifQuery.data.niches));
        }
      }
    }

    setGifsError(gifQuery.isError);
  }, [gifQuery, gifs, users, lastPage]);

  const changeMode = (mode: boolean) => {
    console.debug(`[CollectionFeed] tiles changed to ${mode ? true : false}`);
    setTiles(mode);
  };

  const fetchMore = () => {
    const nextPage = page + 1;
    console.debug(`[CollectionFeed] Fetching more data from page ${nextPage}.`);
    setPage(nextPage);
  };

  return (
    <GifList
      className="collectionItems"
      topic={topic}
      order={order}
      ordering={false}
      topics={false}
      tiles={tiles || props.manage}
      gifs={gifs}
      users={users}
      niches={niches}
      totalLength={totalGifs}
      hasMore={page < pages}
      changeTopic={changeTopic}
      changeOrder={changeOrder}
      changeMode={changeMode}
      fetchMore={fetchMore}
      isError={gifsError}
      isLoading={gifQuery.isLoading}
      manage={props.manage}
      onSelect={props.onSelect}
      source={ViewRegion.Collections}
      rel={rel()}
    />
  );
};
